import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { passwordMatchingValidatior } from '../../_helpers/validators/PasswordMatch.validator';
import { PasswordValidators } from '../../_helpers/validators/PasswordSpecificCharacter.validator';
import { SignUpDTO } from '../../_models/signUpDTO';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SignUpComponent {
  registerForm: FormGroup;
  isFormSend: boolean = false;
  isEmailExist: boolean = false;
  isEmailPending: boolean = false;
  private readonly emailSubject = new Subject<string>();
  model: SignUpDTO = {
    email: '',
    password: '',
    passwordConfirm: '',
    firstName: '',
    lastName: '',
  };
  isPasswordVisible: boolean = false;
  isPasswordConfirmVisible: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.registerForm = this.fb.group(
      {
        email: [
          this.model.email,
          [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')],
        ],
        firstName: [
          this.model.firstName,
          [Validators.required, this.trimRequired(), Validators.pattern('^[^*|\\\\:<>"/?]+$')],
        ],
        lastName: [
          this.model.lastName,
          [Validators.required, this.trimRequired(), Validators.pattern('^[^*|\\\\:<>"/?]+$')],
        ],
        password: [
          this.model.password,
          [
            Validators.required,
            Validators.minLength(10),
            PasswordValidators.patternValidator(new RegExp('(?=.*[()[\\]$@=.^!%*?&])'), {
              requiresSpecialChars: true,
            }),
          ],
        ],
        passwordConfirm: [this.model.passwordConfirm, Validators.required],
      },
      { validators: passwordMatchingValidatior, PasswordValidators }
    );
    this.emailSubject
      .pipe(
        debounceTime(300),
        switchMap((email) => this.authService.CheckEmail(email))
      )
      .subscribe((res) => {
        this.isEmailExist = res.isExist;
        this.isEmailPending = res.isExist && !res.isConfirmed;
      });
  }

  onSearchQueryInput(event: Event): void {
    const emailFiled = (event.target as HTMLInputElement).value;
    if (emailFiled.length !== 0) {
      this.emailSubject.next(emailFiled.trim());
    }
  }

  onSubmit() {
    // if (this.registerForm.valid && !this.isEmailExist) {
    //   this.model.email = this.registerForm.controls['email'].value;
    //   this.model.firstName = this.registerForm.controls['firstName'].value;
    //   this.model.lastName = this.registerForm.controls['lastName'].value;
    //   this.model.password = this.registerForm.controls['password'].value;
    //   this.authService.Register(this.model).subscribe();
    //   this.isFormSend = true;
    // } else {
    //   console.log('invalid form');
    // }
  }

  GoToLogin() {
    this.router.navigateByUrl('/login');
  }

  GoToForgotPassword() {
    this.router.navigateByUrl('/recovery-password');
  }

  resendEmail(): void {
    this.authService.reSendEmailConfirmation(this.registerForm.get('email')!.value).subscribe(() => {
      this.toastr.info('Bestätigung wurde erfolgreich an Ihre E-Mail gesendet');
    });
  }

  private trimRequired() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value.trim()) {
        return { required: true };
      }
      return null;
    };
  }
}
